package org.vreo.devicehub.features.userAuthentication.presentation.login

import org.vreo.devicehub.features.userAuthentication.domain.UserRole

/**
 * User authentication actions. All actions are supported by the user authentication screen.
 */
sealed interface UserLoginActions {
    class OnClearError : UserLoginActions
    data class OnUpdateUsername(val value: String) : UserLoginActions
    data class OnUpdatePassword(val value: String) : UserLoginActions
    data class OnLoginClicked(val handler: ((String, UserRole) -> Unit)? = null) : UserLoginActions
    class OnRegisterClicked : UserLoginActions
    class OnForgotPasswordClicked : UserLoginActions
}